const tabs = {
    get_started: 'Erste Schritte',
    dashboard: 'Dashboard',
    applications: 'Anwendungen',
    api_resources: 'API Ressourcen',
    sign_in_experience: 'Anmeldung & Konto',
    connectors: 'Connectoren',
    enterprise_sso: 'Unternehmens-SSO',
    security: 'Sicherheit',
    webhooks: 'Webhooks',
    organizations: 'Organisationen',
    users: 'Benutzerverwaltung',
    audit_logs: 'Audit-Logs',
    roles: 'Rollen',
    docs: 'Dokumentation',
    tenant_settings: 'Einstellungen',
    mfa: 'Multi-Faktor-Authentifizierung',
    customize_jwt: 'Benutzerdefiniertes JWT',
    signing_keys: 'Signierschlüssel',
    organization_template: 'Organisationstemplate',
};
export default Object.freeze(tabs);
